<template>
    <div class="list-entry my-1 col col-12 col-lg-6">
        <font-awesome-icon :icon="[iconVariant, icon]"/>
        <span class="pl-2">{{ value }}</span>
    </div>
</template>

<script>
export default {
    name: 'ListEntryColumn',
    props: {
        value: {
            type: String,
            require: true
        },
        icon: {
            type: String,
            require: true
        },
        iconVariant: {
            type: String,
            default: 'fas'
        },
    }
}
</script>
